export default "__VITE_ASSET__cf69dcca__"